export default(
  [{
      "title": "HP",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/199851687/hp/background_home201712210406.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_852027-MLA25850355832_082017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/hp#c_id=/home/official-stores/element&c_brand_name=HP&c_element_order=1",
      "items" : [
        {
          "item": "Plotter Hp Designjet T120 Cq891a",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_467211-MLC20506781228_122015-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-435084092-plotter-hp-designjet-t120-cq891a-_JM#c_id=/home/official-stores/item&c_brand_name=HP&c_element_order=1",
          "store": ""
        }, {
          "item": "Impresora Hp Laserjet Pro M426fdw F6w15a",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_274705-MLC25063343434_092016-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-435794521-impresora-hp-laserjet-pro-m426fdw-f6w15a-_JM#c_id=/home/official-stores/item&c_brand_name=HP&c_element_order=1",
          "store": ""
        }, {
          "item": "Pack Hp Plotter T520 Cq893a 36 + Cartuchos 711 + Rollo Papel",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_901032-MLC26154553249_102017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-451110364-pack-hp-plotter-t520-cq893a-36-cartuchos-711-rollo-papel-_JM#c_id=/home/official-stores/item&c_brand_name=HP&c_element_order=1",
          "store": ""
        },
      ]
    },
    {
      "title": "Swatch",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/276252002/swatch/background_home201712191026.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_910314-MLA26156118574_102017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/swatch#c_id=/home/official-stores/element&c_brand_name=Swatch&c_element_order=2",
      "items": [{
          "item": "Reloj Climber Flowery Plateado Swatch",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_601269-MLC28208618072_092018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-453416222-reloj-climber-flowery-plateado-swatch-_JM#c_id=/home/official-stores/item&c_brand_name=Swatch&c_element_order=2",
          "store": ""
        },
        {
          "item": "Reloj Skinblueiron Azul Swatch",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_695287-MLC28208573627_092018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-462038902-reloj-skinblueiron-azul-swatch-_JM#c_id=/home/official-stores/item&c_brand_name=Swatch&c_element_order=2",
          "store": ""
        },
        {
          "item": "Reloj X-district Negro Swatch",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_868735-MLC28208677380_092018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-460700869-reloj-x-district-negro-swatch-_JM#c_id=/home/official-stores/item&c_brand_name=Swatch&c_element_order=2",
          "store": ""
        },
      ]
    },
    {
      "title": "Baby Infanti",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/234945806/babyinfanti/background_home201712210411.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_615298-MLA25716421333_062017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/baby-infanti#c_id=/home/official-stores/element&c_brand_name=Baby%20Infanti&c_element_order=3",
      "items" : [
        {
          "item": "Set Recien Nacido Avent Natural",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_738725-MLC25491121334_042017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-443097660-set-recien-nacido-avent-natural-_JM#c_id=/home/official-stores/item&c_brand_name=Baby%20Infanti&c_element_order=3",
          "store": ""
        }, {
          "item": "Set De Almacenamiento De Leche Materna Avent",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_391725-MLC25491139786_042017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-443097707-set-de-almacenamiento-de-leche-materna-avent-_JM#c_id=/home/official-stores/item&c_brand_name=Baby%20Infanti&c_element_order=3",
          "store": ""
        }, {
          "item": "Silla Auto Convertible Infanti Express Journey Red",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_100325-MLC25405770868_032017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-443099385-silla-auto-convertible-infanti-express-journey-red-_JM#c_id=/home/official-stores/item&c_brand_name=Baby%20Infanti&c_element_order=3",
          "store": ""
        }
      ]
    },
    {
      "title": "La Polar",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/236416659/lapolar/background_home201801091151.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_725072-MLA25716422218_062017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/la-polar#c_id=/home/official-stores/element&c_brand_name=La%20Polar&c_element_order=4",
      "items": [
        {
          "item": "Cocina A Gas Sindelen Nova  Avanti Ch-9400si",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_767430-MLC25755490555_072017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-447245134-cocina-a-gas-sindelen-nova-avanti-ch-9400si-_JM#c_id=/home/official-stores/item&c_brand_name=La%20Polar&c_element_order=4",
          "store": ""
        }, {
          "item": "Refrigerador No Frost Lg Lb33spp 313 Litros",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_912082-MLC26850418414_022018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-455927773-refrigerador-no-frost-lg-lb33spp-313-litros-_JM#c_id=/home/official-stores/item&c_brand_name=La%20Polar&c_element_order=4",
          "store": ""
        }, {
          "item": "Horno Empotrable Mademsa Spazio 110",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_729817-MLC26688099210_012018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-455122689-horno-empotrable-mademsa-spazio-110-_JM#c_id=/home/official-stores/item&c_brand_name=La%20Polar&c_element_order=4",
          "store": ""
        }
      ]
    },
    {
      "title": "Stanley",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/170130005/stanley/background_home201712220913.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_936283-MLA25861236488_082017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/stanley#c_id=/home/official-stores/element&c_brand_name=Stanley&c_element_order=5",
      "items" : [
        {
          "item": "Juego Destornilladores 60-220 Stanley",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_646290-MLC27380323756_052018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-451745391-juego-destornilladores-60-220-stanley-_JM#c_id=/home/official-stores/item&c_brand_name=Stanley&c_element_order=5",
          "store": ""
        }, {
          "item": "Taladro Percutor + Atornillador Impact Schi12c2k-b2 Stanley",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_838823-MLC27380338948_052018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-451633802-taladro-percutor-atornillador-impact-schi12c2k-b2-stanley-_JM#c_id=/home/official-stores/item&c_brand_name=Stanley&c_element_order=5",
          "store": ""
        }, {
          "item": "Juego De Herramientas - 71 Piezas",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_624191-MLC27494562301_062018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-458498560-juego-de-herramientas-71-piezas-_JM#c_id=/home/official-stores/item&c_brand_name=Stanley&c_element_order=5",
          "store": ""
        }
      ]
    },
    {
      "title": "Huawei",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/211983196/huawei/background_home201712070435.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_883452-MLA27599783560_062018-AE.webp",
      "url": "https://tienda.mercadolibre.cl/huawei#c_id=/home/official-stores/element&c_brand_name=Huawei&c_element_order=6",
      "items": [
         {
           "item": "Huawei P20 Lite 32gb Rosado Liberado",
           "image": "https://http2.mlstatic.com/D_Q_NP_2X_777725-MLC27633522373_062018-R.webp",
           "url": "https://articulo.mercadolibre.cl/MLC-458702127-huawei-p20-lite-32gb-rosado-liberado-_JM#c_id=/home/official-stores/item&c_brand_name=Huawei&c_element_order=6",
           "store": ""
         }, {
           "item": "Huawei Tablet T3 10 16gb 2 Gb Ram",
           "image": "https://http2.mlstatic.com/D_Q_NP_2X_780368-MLC27611027978_062018-R.webp",
           "url": "https://articulo.mercadolibre.cl/MLC-461628011-huawei-tablet-t3-10-16gb-2-gb-ram-_JM#c_id=/home/official-stores/item&c_brand_name=Huawei&c_element_order=6",
           "store": ""
         }, {
           "item": "Huawei Band Color Negro Mod. A2",
           "image": "https://http2.mlstatic.com/D_Q_NP_2X_706292-MLC27144704546_042018-R.webp",
           "url": "https://articulo.mercadolibre.cl/MLC-458108143-huawei-band-color-negro-mod-a2-_JM#c_id=/home/official-stores/item&c_brand_name=Huawei&c_element_order=6",
           "store": ""
         }
      ]
    },
    {
      "title": "Dewalt",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/170130005/dewalt/background_home201712220914.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_636853-MLA25716351986_062017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/dewalt#c_id=/home/official-stores/element&c_brand_name=Dewalt&c_element_order=7",
      "items": [
        {
          "item": "Dado 3/8 Cuadrante 1/2 Impact Ready® Dw22842 Dewalt",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_995052-MLC27380334589_052018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-465623217-dado-38-cuadrante-12-impact-ready-dw22842-dewalt-_JM#c_id=/home/official-stores/item&c_brand_name=Dewalt&c_element_order=7",
          "store": ""
        }, {
          "item": "Kit Taladro Percutor Dcd776ac2 Dewalt",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_717153-MLC28271544365_102018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-461834847-kit-taladro-percutor-dcd776ac2-dewalt-_JM#c_id=/home/official-stores/item&c_brand_name=Dewalt&c_element_order=7",
          "store": ""
        }, {
          "item": "Sierra Caladora 500w Dw300-b2c Dewalt",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_981150-MLC27380331452_052018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-434279364-sierra-caladora-500w-dw300-b2c-dewalt-_JM#c_id=/home/official-stores/item&c_brand_name=Dewalt&c_element_order=7",
          "store": ""
        }
      ]
    },
    {
      "title": "Flex",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/173205249/flex/background_home201712200245.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_976076-MLA25716353798_062017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/flex#c_id=/home/official-stores/element&c_brand_name=Flex&c_element_order=8",
      "items": [
        {
          "item": "Colchón 1 Plaza Flex New Entree",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_940215-MLC25143627042_112016-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-440030385-colchon-1-plaza-flex-new-entree-_JM#c_id=/home/official-stores/item&c_brand_name=Flex&c_element_order=8",
          "store": ""
        }, {
          "item": "Colchón 1,5 Plazas Flex New Entree",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_384215-MLC25143628008_112016-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-440030386-colchon-15-plazas-flex-new-entree-_JM#c_id=/home/official-stores/item&c_brand_name=Flex&c_element_order=8",
          "store": ""
        }, {
          "item": "Colchón 1,5 Plazas Box Flex New Entree",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_355215-MLC25143621936_112016-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-440030388-colchon-15-plazas-box-flex-new-entree-_JM#c_id=/home/official-stores/item&c_brand_name=Flex&c_element_order=8",
          "store": ""
        }
      ]
    },
    {
      "title": "Acer",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/252227874/acer/background_home201712210412.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_888178-MLA25716446697_062017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/acer#c_id=/home/official-stores/element&c_brand_name=Acer&c_element_order=9",
      "items": [
        {
          "item": "Mochilas Antirrobo Legend M1713  Black & Blue",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_839620-MLC27624030538_062018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-461783254-mochilas-antirrobo-legend-m1713-black-blue-_JM#c_id=/home/official-stores/item&c_brand_name=Acer&c_element_order=9",
          "store": ""
        }, {
          "item": "Monitor Acer 18,5 Vga Envio Gratis!",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_746457-MLC27483998052_062018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-460599656-monitor-acer-185-vga-envio-gratis-_JM#c_id=/home/official-stores/item&c_brand_name=Acer&c_element_order=9",
          "store": ""
        }, {
          "item": "Acer Convertible S1003-1286 2 En 1",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_656803-MLC25594677918_052017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-454388699-acer-convertible-s1003-1286-2-en-1-_JM#c_id=/home/official-stores/item&c_brand_name=Acer&c_element_order=9",
          "store": ""
        }
      ]
    },
    {
      "title": "Chilemat",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/235754877/chilemat/background_home201712151120.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_826340-MLA25716415492_062017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/chilemat#c_id=/home/official-stores/element&c_brand_name=Chilemat&c_element_order=10",
      "items": [
        {
          "item": "Sierra Ingletadora 1800w Máx. 8  Tc-sm 2131. Einhell C/envío",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_935212-MLC25745335830_072017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-447123480-sierra-ingletadora-1800w-max-8-tc-sm-2131-einhell-cenvio-_JM#c_id=/home/official-stores/item&c_brand_name=Chilemat&c_element_order=10",
          "store": ""
        }, {
          "item": "Sierra Banco 1800 Watts Tc-ts 2025 U. Einhell (envío Gratis)",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_963888-MLC25909954226_082017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-445632713-sierra-banco-1800-watts-tc-ts-2025-u-einhell-envio-gratis-_JM#c_id=/home/official-stores/item&c_brand_name=Chilemat&c_element_order=10",
          "store": ""
        }, {
          "item": "Aerógrafo Doble Acción 30 Cc. Indura (envío Gratis)",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_664515-MLC25253880133_122016-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-453093934-aerografo-doble-accion-30-cc-indura-envio-gratis-_JM#c_id=/home/official-stores/item&c_brand_name=Chilemat&c_element_order=10",
          "store": ""
        }
      ]
    },
    {
      "title": "Sony",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/177969871/sony/background_home201803271035.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_947728-MLA25970851050_092017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/sony#c_id=/home/official-stores/element&c_brand_name=Sony&c_element_order=11",
      "items": [
        {
          "item": "Sony Sistema De Audio En Casa Con Bluetooth Mhc-v11",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_206405-MLC20858878750_082016-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-437833819-sony-sistema-de-audio-en-casa-con-bluetooth-mhc-v11-_JM#c_id=/home/official-stores/item&c_brand_name=Sony&c_element_order=11",
          "store": ""
        }, {
          "item": "Sony 4k 55´ Ultra Hd Android Tv Smart Tv Xbr55x80",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_910025-MLC25616122406_052017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-445680672-sony-4k-55-ultra-hd-android-tv-smart-tv-xbr55x80-_JM#c_id=/home/official-stores/item&c_brand_name=Sony&c_element_order=11",
          "store": ""
        }, {
          "item": "Sony Walkman Con Usb Integrado Nwz-b183f",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_523125-MLC25380250493_022017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-442718738-sony-walkman-con-usb-integrado-nwz-b183f-_JM#c_id=/home/official-stores/item&c_brand_name=Sony&c_element_order=11",
          "store": ""
        }
      ]
    },
    {
      "title": "Lego",
      "bgimg": "https://http2.mlstatic.com/optimize/o:f_webp/resources/largesellers/234945806/lego/background_home201712200941.jpg",
      "logo": "https://http2.mlstatic.com/D_Q_NP_2X_605094-MLA26268240492_102017-AE.webp",
      "url": "https://tienda.mercadolibre.cl/lego#c_id=/home/official-stores/element&c_brand_name=Lego&c_element_order=12",
      "items": [
        {
          "item": "Lego Juego Caja Mediana De Ladrillos Creativos Lego",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_833980-MLC26096881998_092017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-450604804-lego-juego-caja-mediana-de-ladrillos-creativos-lego-_JM#c_id=/home/official-stores/item&c_brand_name=Lego&c_element_order=12",
          "store": ""
        }, {
          "item": "Lego Juego Caja Grande De Ladrillos Creativos Lego",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_824413-MLC26096884608_092017-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-450604767-lego-juego-caja-grande-de-ladrillos-creativos-lego-_JM#c_id=/home/official-stores/item&c_brand_name=Lego&c_element_order=12",
          "store": ""
        }, {
          "item": "Lego Star Wars Transformación De Darth Vader",
          "image": "https://http2.mlstatic.com/D_Q_NP_2X_735172-MLC27432839060_052018-R.webp",
          "url": "https://articulo.mercadolibre.cl/MLC-460187010-lego-star-wars-transformacion-de-darth-vader-_JM#c_id=/home/official-stores/item&c_brand_name=Lego&c_element_order=12",
          "store": ""
        }
      ]
    }
  ]
)